// src/redux/selectedNodesSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedNodes: [],
};

const selectedNodesSlice = createSlice({
  name: 'selectedNodes',
  initialState,
  reducers: {
    toggleNodeSelection: (state, action) => {
      // console.log(action.payload, "alldataselectslol");
      const nodeId = action.payload;
      // const index = state.selectedNodes.findIndex((item) => item.nodeId === nodeId.nodeId);
      // console.log(index, "this is index of unselect data")
      // if (index === -1) {
        state.selectedNodes.push(nodeId);
      // } 
      // else {
      //   state.selectedNodes.splice(index, 1);
      // }
    },
    unselectNode: (state, action) => {
      const nodeId = action.payload;
      // Find the node index
      const index = state.selectedNodes.findIndex((item) => item.nodeId === nodeId.nodeId);
      if (index !== -1) {
        // Remove node from selectedNodes array
        state.selectedNodes.splice(index, 1);
      }
    },
    clearSelectedNodes: (state) => {
      // Clear all selected nodes
      state.selectedNodes = [];
    },
    setSelectedNodes: (state, action) => {
      // Set selected nodes to a specific array
      state.selectedNodes = [...state.selectedNodes, ...action.payload];
    },
    selectedNodeLogout: (state) => {
      state.selectedNodes = [];
    },
  },
});

export const { toggleNodeSelection, clearSelectedNodes, setSelectedNodes , unselectNode, selectedNodeLogout } = selectedNodesSlice.actions;

// Selector to get the list of selected node IDs
export const selectSelectedNodes = (state) => state.selectedNodes.selectedNodes;

export default selectedNodesSlice.reducer;
